"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("./roomViewStore");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const api_1 = require("@/api");
const react_lottie_player_1 = __importDefault(require("react-lottie-player"));
const functions_1 = require("@/common/functions");
const detect_utils_1 = require("@/common/detect_utils");
const errors_1 = require("@/common/errors");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ open }) {
    var _a, _b;
    const roomData = (0, react_redux_1.useSelector)((state) => state.roomData);
    const { register, formState: { errors }, setError, clearErrors, handleSubmit, } = (0, react_hook_form_1.useForm)({ mode: 'onChange' });
    const onSecretPasswordChange = () => clearErrors('root.secretPwInvalid');
    const { t } = (0, react_i18next_1.useTranslation)();
    const secretCodeRequiredMsg = t('입장을 위해 비밀번호를 작성해주세요');
    const dispatch = (0, react_redux_1.useDispatch)();
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const submitSecretCode = handleSubmit(({ secret_password }) => __awaiter(this, void 0, void 0, function* () {
        setIsPending(true);
        yield (0, api_1.postData)(`/api/v1/room/${roomData.id}/password-confirm`, { secret_password })
            .then(res => dispatch((0, roomViewStore_1.getRoomViewData)(Object.assign(Object.assign({}, roomData), res.data.result))))
            .catch(err => {
            var _a, _b;
            const alertType = (_b = (_a = err.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type;
            if (alertType === 40001)
                window.location.reload();
            else if (alertType === 40002) {
                setError('root.secretPwInvalid', {
                    type: 'invalid',
                    message: `${t('비밀번호가 틀렸어요')}..🥺`,
                });
            }
            else
                alert((0, errors_1.commonErrorMsg)() + `(errorCode: ${alertType})`);
            setIsPending(false);
        });
    }));
    const submitSecretCodeOnEnter = (e) => {
        !isPending && e.key === 'Enter' && submitSecretCode();
    };
    return ((0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ open: open, slotProps: { backdrop: { sx: { bgcolor: 'var(--gray-80)' } } }, PaperProps: {
            sx: {
                width: '335px',
                padding: '14px',
                borderRadius: '16px',
                margin: 0,
            },
        } }, { children: (0, jsx_runtime_1.jsxs)(SecretFormWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "secret_form_hint" }, { children: [(0, jsx_runtime_1.jsx)(react_lottie_player_1.default, { path: `${process.env.CDN_URL}/assets/animations/secret_key.json`, play: true, loop: true, css: { maxWidth: '92px' } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "hint_title" }, { children: t('작가님 힌트') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "hint_contents" }, { children: roomData.secret_hint }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "secret_form_input_wrapper" }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ className: "secret_form_input", maxLength: 64, placeholder: t('비밀번호 작성') }, register('secret_password', {
                            required: secretCodeRequiredMsg,
                            validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || secretCodeRequiredMsg,
                            onChange: onSecretPasswordChange,
                        }), { onKeyDown: submitSecretCodeOnEnter })), ((_a = errors.root) === null || _a === void 0 ? void 0 : _a.secretPwInvalid) && (0, jsx_runtime_1.jsx)("h5", { children: (_b = errors.root) === null || _b === void 0 ? void 0 : _b.secretPwInvalid.message }), errors.secret_password && (0, jsx_runtime_1.jsx)("h6", { children: errors.secret_password.message })] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "secret_form_btn_wrapper" }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ id: "cancel_btn", onClick: () => {
                                if (window.isWebViewStack)
                                    (0, webview_app_1.postMessageToWVA)('POPSTACK');
                                else
                                    (0, functions_1.goBackOrMain)();
                            } }, { children: t('취소') })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ id: "enter_btn", onClick: submitSecretCode, disabled: isPending }, { children: isPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 20, color: "inherit", thickness: 4 })) : ((0, jsx_runtime_1.jsx)("span", { children: t('입장하기') })) }))] }))] }) })));
}
exports.default = default_1;
const SecretFormWrapper = styled_1.default.div `
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  .secret_form_hint {
    display: flex;
    flex-direction: column;
    align-items: center;
    #hint_title {
      font-size: 18px;
      font-weight: bold;
      color: var(--primary-dark);
    }
    #hint_contents {
      margin-top: 10px;
      line-height: 26px;
      font-size: 16px;
      word-break: break-all;
    }
  }
  .secret_form_input_wrapper {
    input {
      width: 100%;
      height: 48px;
      padding: 0 14px;
      border-radius: 8px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      font-size: 16px;
      outline: none;
    }
    h5,
    h6 {
      margin-top: 3px;
      line-height: 18px;
      font-size: 14px;
    }
    h5 {
      color: #eb5757;
    }
    h6 {
      color: rgba(0, 0, 0, 0.8);
    }
  }
  .secret_form_btn_wrapper {
    display: flex;
    column-gap: 8px;
    button {
      width: 100%;
      height: 40px;
      border-radius: 8px;
      font-size: 15px;
    }
    #cancel_btn {
      border: 1px solid rgba(0, 0, 0, 0.1);
      color: rgba(0, 0, 0, 0.8);
      background-color: white !important;
    }
    #enter_btn {
      font-weight: bold;
      color: white;
      background-color: var(--primary-main) !important;
    }
  }
`;
